// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_21QhLjs","checkbox":"_1WLTxJD","checked":"_2spObRa","disabled":"_36cODbO","labelDisabled":"_2u3Cf8Y","label":"_1lvKSE-"};